// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionCircleFilledSvg from "@fishx/icons-svg/es/asn/QuestionCircleFilled";
import FishxIcon from '../components/FishxIcon';

var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleFilledSvg
  }));
};

QuestionCircleFilled.displayName = 'QuestionCircleFilled';
export default React.forwardRef(QuestionCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QuestionCircleFilled.js
// module id = 3945
// module chunks = 0